import { render, staticRenderFns } from "./disposalCow.vue?vue&type=template&id=0f9ca7d6&scoped=true&"
import script from "./disposalCow.vue?vue&type=script&lang=js&"
export * from "./disposalCow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9ca7d6",
  null
  
)

export default component.exports